<app-header></app-header>
<div class="title"></div>
<div class="container margin-top-70" style="padding: 0px;">
  <div class="col-md-6 mt-6">
    <table class="table table-bordered">
      <tbody>
        <tr>
          <td class="v-align-m">Email Address</td>
          <td>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="emailAddress"
              placeholder=""
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="container table-responsive">
  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
    <button
      [disabled]="showSearchLoading"
      type="submit"
      class="btn btn-primary btn-pkt"
      (click)="searchProduct()"
    >
      {{searchBtnText}}
      <i class="bi bi-search ps-1" *ngIf="!showSearchLoading"></i>
      <span
        *ngIf="showSearchLoading"
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
    </button>
    <button
      class="btn btn-primary btn-pkt"
      type="button"
      (click)="downloadReport()"
    >
      <i class="fa fa-download"></i> Download
    </button>
    <button class="btn btn-primary btn-pkt" (click)="clearFilters()">
      Reset<i class="bi bi-trash ps-1"></i>
    </button>
  </div>
</div>

<div>
  <div class="container">
    <table
      class="table table-hover table-bordered table-striped mt-2 pkt-table-style"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col">Author Name</th>
          <th scope="col">Email Address</th>
          <th scope="col">Netsuite ID</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of products; let i = index;">
          <td>{{product.name}}</td>
          <td>{{product.email_address}}</td>
          <td>{{product.netsuite_internal_id}}</td>
        </tr>
      </tbody>
    </table>
    <!-- Total Products {{totalProducts}} -->
  </div>
</div>
<div class="container">
  <app-pagination
    [maxSize]="maxSize"
    [pageSize]="pageSize"
    [collectionSize]="totalProducts"
    (pageChanged)="updatePageData($event)"
  ></app-pagination>
</div>

<app-footer></app-footer>
